import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { I18nService, Lang } from './core/services/i18n.service';
import { AuthService } from './core/services/auth.service';
import { LoginComponent } from './features/auth/login/login.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, LoginComponent],
  template: `
    <!-- Login screen -->
    <app-login *ngIf="!(authService.isLoading$ | async) && !authService.isAuthenticated"></app-login>

    <!-- Main app -->
    <div class="app-layout" *ngIf="!(authService.isLoading$ | async) && authService.isAuthenticated">
      <!-- Navigation -->
      <nav class="main-nav" role="navigation" aria-label="Navigation principale">
        <div class="nav-brand">
          <span class="brand-icon">📊</span>
          <span class="brand-text">KPI COA</span>
          <span class="role-badge" *ngIf="authService.isAdmin">ADMIN</span>
        </div>

        <div class="nav-groups">
          <!-- Group: Revue de performance -->
          <div class="nav-group" [class.expanded]="expandedGroup === 'perf'">
            <button class="nav-group-header" (click)="toggleGroup('perf')">
              <span class="group-arrow">{{ expandedGroup === 'perf' ? '▾' : '▸' }}</span>
              <span class="group-label">{{ i18n.t('nav.perfGroup') }}</span>
            </button>
            <ul class="nav-group-items" *ngIf="expandedGroup === 'perf'">
              <li>
                <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="nav-icon">🏠</span>
                  {{ i18n.t('nav.dashboard') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/saisie" routerLinkActive="active">
                  <span class="nav-icon">📝</span>
                  {{ i18n.t('nav.saisie') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/qualitatif" routerLinkActive="active">
                  <span class="nav-icon">📋</span>
                  {{ i18n.t('nav.qualitatif') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/cibles" routerLinkActive="active">
                  <span class="nav-icon">⚙️</span>
                  {{ i18n.t('nav.cibles') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/definitions" routerLinkActive="active">
                  <span class="nav-icon">📄</span>
                  Définitions KPI
                </a>
              </li>
              <li>
                <a routerLink="/documentation" routerLinkActive="active">
                  <span class="nav-icon">📖</span>
                  {{ i18n.t('nav.documentation') }}
                </a>
              </li>
            </ul>
          </div>
          <!-- Group: Matrice d'adhésion COA -->
          <div class="nav-group" [class.expanded]="expandedGroup === 'adhesion'">
            <button class="nav-group-header" (click)="toggleGroup('adhesion')">
              <span class="group-arrow">{{ expandedGroup === 'adhesion' ? '▾' : '▸' }}</span>
              <span class="group-label">{{ i18n.t('adhesion.nav.group') }}</span>
            </button>
            <ul class="nav-group-items" *ngIf="expandedGroup === 'adhesion'">
              <li>
                <a routerLink="/adhesion-matrix" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="nav-icon">📊</span>
                  {{ i18n.t('adhesion.nav.global') }}
                </a>
              </li>
              <li>
                <a routerLink="/adhesion-matrix/par-site" routerLinkActive="active">
                  <span class="nav-icon">🏭</span>
                  {{ i18n.t('adhesion.nav.globalSite') }}
                </a>
              </li>
              <li>
                <a routerLink="/adhesion-matrix/synthese" routerLinkActive="active">
                  <span class="nav-icon">📈</span>
                  {{ i18n.t('adhesion.nav.sector') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/adhesion-matrix/evaluation" routerLinkActive="active">
                  <span class="nav-icon">📝</span>
                  {{ i18n.t('adhesion.nav.evaluation') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/adhesion-matrix/derniere-evaluation" routerLinkActive="active">
                  <span class="nav-icon">🕐</span>
                  {{ i18n.t('adhesion.nav.lastEval') }}
                </a>
              </li>
              <li>
                <a routerLink="/adhesion-matrix/criteres" routerLinkActive="active">
                  <span class="nav-icon">📖</span>
                  {{ i18n.t('adhesion.nav.documentation') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/adhesion-matrix/actions" routerLinkActive="active">
                  <span class="nav-icon">⚡</span>
                  {{ i18n.t('adhesion.nav.actions') }}
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/adhesion-matrix/admin" routerLinkActive="active">
                  <span class="nav-icon">⚙️</span>
                  {{ i18n.t('adhesion.nav.admin') }}
                </a>
              </li>
            </ul>
          </div>
          <!-- Group: Revue de performance Produit -->
          <div class="nav-group" [class.expanded]="expandedGroup === 'product'">
            <button class="nav-group-header" (click)="toggleGroup('product')">
              <span class="group-arrow">{{ expandedGroup === 'product' ? '▾' : '▸' }}</span>
              <span class="group-label">Revue Perf. Produit</span>
            </button>
            <ul class="nav-group-items" *ngIf="expandedGroup === 'product'">
              <li>
                <a routerLink="/product-review" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <span class="nav-icon">🏠</span>
                  Dashboard
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/product-review/saisie" routerLinkActive="active">
                  <span class="nav-icon">📝</span>
                  Saisie
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/product-review/qualitatif" routerLinkActive="active">
                  <span class="nav-icon">📋</span>
                  Qualitatif
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/product-review/cibles" routerLinkActive="active">
                  <span class="nav-icon">⚙️</span>
                  Cibles
                </a>
              </li>
              <li *ngIf="authService.isAdmin">
                <a routerLink="/product-review/definitions" routerLinkActive="active">
                  <span class="nav-icon">📄</span>
                  Définitions KPI
                </a>
              </li>
              <li>
                <a routerLink="/product-review/documentation" routerLinkActive="active">
                  <span class="nav-icon">📖</span>
                  Documentation
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Global items (outside groups) -->
        <ul class="nav-links nav-global">
          <li *ngIf="authService.isAdmin">
            <a routerLink="/specialistes" routerLinkActive="active">
              <span class="nav-icon">👤</span>
              {{ i18n.t('nav.specialistes') }}
            </a>
          </li>
          <li *ngIf="authService.isSuperAdmin">
            <a routerLink="/utilisateurs" routerLinkActive="active">
              <span class="nav-icon">👥</span>
              Utilisateurs
            </a>
          </li>
        </ul>

        <div class="nav-footer">
          <div class="user-info" *ngIf="authService.user">
            <span class="user-email">{{ authService.user.email }}</span>
          </div>
          <button class="logout-btn" (click)="logout()">Déconnexion</button>
          <div class="lang-selector">
            <button *ngFor="let l of langs"
                    class="lang-btn"
                    [class.lang-active]="i18n.lang === l.code"
                    (click)="i18n.setLang(l.code)">
              {{ l.label }}
            </button>
          </div>
        </div>
      </nav>

      <!-- Content -->
      <main class="main-content">
        <div class="branding-banner">
          <span class="brand-name">Rio Tinto</span>
          <span class="brand-separator">—</span>
          <span class="brand-unit">Centre Opérationnel Atlantique</span>
        </div>
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [`
    .app-layout {
      display: flex;
      min-height: 100vh;
      background: #f5f7fa;
    }

    .main-nav {
      width: 220px;
      background: #1a1a2e;
      color: white;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      z-index: 100;
    }

    .nav-brand {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 16px 16px;
      border-bottom: 1px solid rgba(255,255,255,0.1);
      margin-bottom: 12px;
    }

    .brand-icon {
      font-size: 1.3rem;
    }

    .brand-text {
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

    .role-badge {
      font-size: 0.55rem;
      font-weight: 700;
      background: rgba(52, 152, 219, 0.3);
      color: #3498db;
      padding: 2px 6px;
      border-radius: 4px;
      letter-spacing: 0.05em;
    }

    /* Nav groups */
    .nav-groups {
      flex: 1;
      overflow-y: auto;
    }

    .nav-group {
      margin-bottom: 4px;
    }

    .nav-group-header {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      padding: 10px 16px;
      background: none;
      border: none;
      color: rgba(255,255,255,0.9);
      font-size: 0.8rem;
      font-weight: 600;
      cursor: pointer;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      transition: all 0.15s;
    }

    .nav-group-header:hover {
      background: rgba(255,255,255,0.05);
    }

    .group-arrow {
      font-size: 0.7rem;
      color: rgba(255,255,255,0.5);
    }

    .group-label {
      flex: 1;
      text-align: left;
    }

    .nav-group-items {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .nav-group-items li a {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px 8px 32px;
      color: rgba(255,255,255,0.65);
      text-decoration: none;
      font-size: 0.82rem;
      font-weight: 500;
      transition: all 0.15s;
      border-left: 3px solid transparent;
    }

    .nav-group-items li a:hover {
      background: rgba(255,255,255,0.05);
      color: white;
    }

    .nav-group-items li a.active {
      background: rgba(52, 152, 219, 0.15);
      color: #3498db;
      border-left-color: #3498db;
    }

    /* Global items */
    .nav-global {
      border-top: 1px solid rgba(255,255,255,0.1);
      padding-top: 8px;
      margin-top: 8px;
    }

    .nav-links {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .nav-links li a {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      color: rgba(255,255,255,0.65);
      text-decoration: none;
      font-size: 0.82rem;
      font-weight: 500;
      transition: all 0.15s;
      border-left: 3px solid transparent;
    }

    .nav-links li a:hover {
      background: rgba(255,255,255,0.05);
      color: white;
    }

    .nav-links li a.active {
      background: rgba(52, 152, 219, 0.15);
      color: #3498db;
      border-left-color: #3498db;
    }

    .nav-icon {
      font-size: 0.95rem;
    }

    .main-content {
      flex: 1;
      margin-left: 220px;
      min-height: 100vh;
    }

    /* Branding banner */
    .branding-banner {
      background: #e03c31;
      padding: 10px 24px;
      display: flex;
      align-items: baseline;
      gap: 8px;
    }
    .brand-name { font-size: 1.2rem; font-weight: 700; color: white; font-family: Georgia, 'Times New Roman', serif; letter-spacing: -0.01em; }
    .brand-separator { color: rgba(255,255,255,0.6); font-size: 0.9rem; }
    .brand-unit { font-size: 0.78rem; color: rgba(255,255,255,0.9); font-weight: 500; letter-spacing: 0.02em; }

    .nav-footer {
      margin-top: auto;
      padding: 12px 16px;
      border-top: 1px solid rgba(255,255,255,0.1);
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .user-info {
      padding: 4px 0;
    }

    .user-email {
      font-size: 0.7rem;
      color: rgba(255,255,255,0.5);
      word-break: break-all;
    }

    .logout-btn {
      width: 100%;
      padding: 8px;
      border: 1px solid rgba(255,255,255,0.2);
      border-radius: 6px;
      background: transparent;
      color: rgba(255,255,255,0.7);
      font-size: 0.75rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.15s;
    }

    .logout-btn:hover {
      background: rgba(231, 76, 60, 0.2);
      color: #e74c3c;
      border-color: #e74c3c;
    }

    .lang-selector {
      display: flex;
      gap: 4px;
    }

    .lang-btn {
      flex: 1;
      padding: 6px 4px;
      border: 1px solid rgba(255,255,255,0.2);
      border-radius: 6px;
      background: transparent;
      color: rgba(255,255,255,0.6);
      font-size: 0.7rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.15s;
    }

    .lang-btn:hover {
      background: rgba(255,255,255,0.1);
      color: white;
    }

    .lang-active {
      background: rgba(52, 152, 219, 0.3);
      color: #3498db;
      border-color: #3498db;
    }
  `]
})
export class AppComponent {
  title = 'KPI COA';
  expandedGroup: string | null = 'perf';
  langs: { code: Lang; label: string }[] = [
    { code: 'fr', label: 'FR' },
    { code: 'en', label: 'EN' },
    { code: 'is', label: 'IS' },
  ];

  constructor(
    public i18n: I18nService,
    public authService: AuthService,
  ) {}

  toggleGroup(group: string): void {
    this.expandedGroup = this.expandedGroup === group ? null : group;
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}
